import { LoaderFunctionArgs, defer } from 'react-router-dom'
import { isAppStateReady } from '$appStore'
import { logger } from '$utils'
import useComplianceStore from '../../store'

export default async function loader({ params }: LoaderFunctionArgs) {
  logger.debug(
    '[loader] About to await AppState being ready in View Pay Adjustment Package loader'
  )
  await isAppStateReady()
  logger.debug(
    '[loader] AppState should now be ready in View Pay Adjustment Package loader'
  )

  const getPayAdjustmentPackage = params.packageId
    ? useComplianceStore.getState().getPayAdjustmentPackage(params.packageId)
    : null

  return defer({
    data: Promise.all([getPayAdjustmentPackage])
      .then(() => true)
      .catch((error) => {
        logger.error('View Pay Adjustment Package Promise.all error', error)
        return false
      }),
  })
}
